import React from 'react';
import './UpcomingEvents.css';

const UpcomingFranchiseEvents = ({ Image, Title, Type, Id, Location, City, Certification, YearOfEstablishment, routeOnPage }) => {
    return (
        <>
            <div className="col-lg-4 col-md-4 col-sm-12 mr-1 mb-3 topSkills topSkills__contentDisplay franchise--card" key={Id}
                onClick={routeOnPage}>
                <div className="card-events">
                    <div className="card-events-body d-flex flex-column topSkills__content">
                        {/* {(Image && Image != "") && <div className="justify-content-center align-items-center">
                            <img src={Image} alt="Store Name" className="img-fluid productTemplate__companyLogo" />
                        </div>} */}
                        <div className="card-events-details">
                            <h5 className="card-events-title">{Title}</h5>
                            {City && <p className="card-events-title">City: <b>{City}</b></p>}
                            {Type && <p className="card-events-title">Type: <b>{Type}</b></p>}
                            {Certification && <p className="card-events-title">Certification: <b>{Certification}</b></p>}
                            {YearOfEstablishment && <p className="card-events-title">Year of Establishment: <b>{YearOfEstablishment}</b></p>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpcomingFranchiseEvents
